import { createUseStyles } from 'react-jss';
export const useTooltipStyles = createUseStyles(() => ({
    tooltip: {
        backgroundColor: '#0A0D14',
        color: '#FFFFFF',
        borderRadius: '4px',
        padding: '4px 8px',
        boxSizing: 'border-box',
        width: 'max-content',
        maxWidth: 'calc(100vw - 10px)',
        zIndex: 1000
    }
}));
